import { render, staticRenderFns } from "./Dashboards_admission.vue?vue&type=template&id=d048136e&scoped=true&"
import script from "./Dashboards_admission.vue?vue&type=script&lang=js&"
export * from "./Dashboards_admission.vue?vue&type=script&lang=js&"
import style0 from "./Dashboards_admission.vue?vue&type=style&index=0&id=d048136e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d048136e",
  null
  
)

export default component.exports